import { broadcastLogout } from "@selector/shared";
import { type FC, useEffect } from "react";
import { useDispatch } from "react-redux";

import { logout } from "@/redux/modules/auth.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";

export const LogoutPage: FC = () => {
  const dispatch = useDispatch<ReduxDispatch>();
  // const navigate = useNavigate();

  useEffect(() => {
    broadcastLogout({ logout: true });
    void dispatch(logout());
  }, [dispatch]);

  return null;
};
